<template lang="pug">
  div
    v-input.d-none(
      :value="value"
      :rules="rules")
    v-color-picker.mx-auto(
      @input="onInput"
      :value="model"
      :rules="rules"
      :label="label")
    div.error--text(v-if="error") {{ error }}
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    value: String,
    rules: {
      type: Array,
      default: () => []
    },
    label: String
  },

  setup (props, { emit }) {
    const model = computed({
      get: () => props.value,
      set: value => {
        emit(`input`, value)
      }
    })

    const error = computed(() =>
      props.rules
        .map(rule => rule(model.value))
        .filter(
          value => value !== true
        )[0]
    )

    let firstTime = true
    const onInput = value => {
      if (firstTime) {
        firstTime = false
      } else {
        emit(`input`, value)
      }
    }

    return {
      model,
      error,
      onInput
    }
  }
}
</script>
